var Cookies = require("js-cookie");

function get(cname) {
  // //console.log("TCL: get -> cname", cname);
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  // //console.log("TCL: get -> decodedCookie", decodedCookie);
  var ca = decodedCookie.split(";");
  // //console.log("TCL: get -> ca", ca);
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  let value = Cookies.get(cname);
  return value !== undefined ? value : null;
}

function set(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
  Cookies.set(name, value, {
    expires: days ? days : 1
  });
}

function remove(name) {
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  Cookies.remove(name);
}
export default {
  set,
  get,
  remove
};
